import React from 'react';

const HowToVideos = () => {
  return (
    <section className="py-5" style={{backgroundColor: "#f8f9fa"}}>
        <div className="container">
            <div className="text-center mb-5">
                <h2 className="display-5 fw-bold mb-3">How-To Videos</h2>
            </div>
            <div className="row g-4">
                <div className="col-lg-4 col-md-6">
                  <article className="card h-100 shadow-sm">
                    <div className="video-placeholder bg-secondary d-flex align-items-center justify-content-center" style={{height: "200px"}}>
                      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/n5MrwdqO1jA?si=aQ9RNf-nZqGWkzGi" title="How to get an entity overview" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>

                    <div className="card-body">
                      <h3 className="how-to-video-card-title">Learn How to Get an Entity Overview</h3>
                      <p className="card-text">Learn more about more than 1,800 state and local government entities throughout Utah.  Information available includes their annual surplus or deficit, associated expenses and revenues by different categories.  This tool helps taxpayers better understand and know where their money–taxes–are spent and collected. </p>
                    </div>
                  </article>
                </div>

                <div className="col-lg-4 col-md-6">
                  <article className="card h-100 shadow-sm">
                    <div className="video-placeholder bg-secondary d-flex align-items-center justify-content-center" style={{height: "200px"}}>
                      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/_-M3hWXw4GI?si=kBUVsPv3q1dR_azQ" title="Compensation by job title search (Advanced)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                    <div className="card-body">
                      <h3 className="how-to-video-card-title">Compensation by Job Title Search (Advanced)</h3>
                      <p className="card-text">Find information on more than 150 different job descriptions.  Learn how to search by different titles and do advanced or custom searches to find whatever you are looking for.</p>
                    </div>
                  </article>
                </div>
                
                <div className="col-lg-4 col-md-6">
                  <article className="card h-100 shadow-sm">
                    <div className="video-placeholder bg-secondary d-flex align-items-center justify-content-center" style={{height: "200px"}}>
                        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/T73XQd_Qnus?si=QSuV8kAdt40GAzzR" title="Employee Compsensation Search" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                    <div className="card-body">
                        <h3 className="how-to-video-card-title">Employee Compensation Search</h3>
                        <p className="card-text">Find salaries of employees from state and local entities across Utah.
                        Records show entity names and job titles and the associated wage and benefits associated with each individual by year.
                        </p>
                    </div>
                  </article>
                </div>
            </div>
        </div>
    </section>
  );
};

export default HowToVideos;
